import { useContext } from 'react'
import Context from './HeaderSizeContext'

const useHeaderSize = () => useContext(Context)

export default useHeaderSize
